import api from '~config/api';

const getProductById = (id) => api.get(`v1/products/${id}`);

export default {
  getProductById
};
